export type UnauthorizedReason = 'invalid' | 'expired' | 'consumed'

export class UnauthorizedError extends Error {
    reason?: UnauthorizedReason

    constructor(reason?: UnauthorizedReason) {
        super('Unauthorized')
        this.name = 'UnauthorizedError'
        this.reason = reason
    }
}

export class ApiError extends Error {
    readonly status: number
    readonly body: unknown

    constructor(message: string, status: number, body: unknown) {
        super(message)
        this.name = 'ApiError'
        this.status = status
        this.body = body
    }
}
